"use strict";
function identity(x) {
    return x;
}
exports.identity = identity;
//# sourceMappingURL=identity.js.map


//////////////////
// WEBPACK FOOTER
// C:/Users/noomo/Desktop/project/newCefKid/cefapp2/node_modules/rxjs/util/identity.js
// module id = ../../../../rxjs/util/identity.js
// module chunks = vendor